module.exports = __webpack_public_path__ + "media/images/help-center/help-center-icon-money-dd89fa852e5146844db445b4e8769faa.png";